const mutations = {
  SET_USERINFO(state, userInfo) {
    state.USERINFO = userInfo;
  },
  SET_MENUS(state, menus) {
    state.MENUS = menus;
  },
  SET_TOKEN(state, token) {
    state.TOKEN = token;
  },
};

export default mutations;
